module.exports = __webpack_public_path__ + "img/yield.f2ef1b31.png";